export default "__VITE_ASSET__DVefkjEd__"